import { Map, OrderedMap } from 'immutable';
import { records as deviceRecords } from '@saucelabs/sl-module-devices-rdc';

import * as types from './types';

const initialState = new Map({
  count: 0,
  loading: false,
  filters: Map(),
  items: new OrderedMap(),
});

const devicesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.DEVICE_LIST_GET.REQUEST:
      return state.set('loading', true);
    case types.DEVICE_LIST_GET.SUCCESS: {
      const items = payload.entities.reduce((acc, item) => {
        acc[item.descriptorId] = new deviceRecords.DeviceDescriptor(item);
        return acc;
      }, {});

      return state.withMutations((mutable) => {
        mutable.set('loading', false);
        mutable.set('filters', new Map(payload.facets));
        mutable.set('items', new OrderedMap(items));
      });
    }
    case types.DEVICE_LIST_GET.FAILURE:
      return state.set('loading', false);
    case types.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default devicesReducer;
